<template>
  <Modal
    :id="'cmp-edit-checklist'"
    @cancelled="onCancel"
  >
    <template slot="header">
      {{$t('edit_checklist')}}
    </template>

    <template slot="body">
      <DSortableList
        v-if="customChecklists"
        :items="customChecklists"
        :labelKey="'name'"
        @onBlur="onCCIInputBlur"
        @onDelete="deleteCCI"
      />
    </template>

    <template slot="options">
      <button class="dt-button v1 s6" @click.stop="addChecklist"> {{$t('new_checklist')}} </button>
      <button class="dt-button s6" @click.stop="onCancel"> {{$t('close')}} </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../modal/modal";
import DSortableList from "@plugins/sortable-list/dtsortable-list";
export default {
  components: {
    Modal,
    DSortableList
  },
  props: {
    customChecklists: {
      type: Array
    }
  },
  data: function() {
    return {
      checklist_title: ""
    };
  },
  methods: {
    addChecklist: function(e) {
      this.$emit("OPEN_ADD");
    },
    onCCIInputBlur: function( item) {
      //if (e.target.value !== ccItem.name) {
        // console.log("RRRRRRRRRRRR",item)
        this.$emit("EDIT", { item, newName: item.newName });
     // }
    },
    onCancel: function(e) {
      this.$emit("CANCEL", false);
    },
    deleteCCI: function(item) {
      this.$emit("DELETE", item);
    }
  }
};
</script>

<style lang="scss" scoped>
.dt-list-item {
  border-bottom-color: transparent !important;
  margin: 5px 0px;
  padding: 5px 0px;

  .dt-list-item--options {
    max-width: 26px;
  }
}

.dt-modal--body {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.remove-cci {
  i {
    font-size: 13px;
    padding: 5px;
    transition: 200ms ease-out;

    &:hover {
      color: black;
      transform: scale(1.2);
    }
  }

  &:active,
  &:focus {
    outline: none;
    transform: scale(1);

    text-shadow: 0.3px 0.3px #000000ad;
  }
}
</style>
